import React from 'react'
import PropTypes from 'prop-types';

export class DecimalField extends React.Component {

    static formatValue(value) {
        let v = parseFloat(value);
        if (isNaN(v)) {
            v = 0;
        }

        return v;
    }

    render() {
        var formattedValue = this.getValue();
        let attrs = {
            defaultValue: formattedValue
        }

        return (
            <input
                id={this.props.id}
                type="text"
                pattern="\d"
                value={value}
                className={this.props.className}
                onChange={e => {
                    let currentValue = e.target.value.replace(',', '.');
                    let decimalValue = ValueFormatter.decimal(e.target.value, formattedValue);
                    e.target.value = decimalValue;
                    this.setState({
                        numberInputRefId: e.target.id
                    }, () => {
                        var number = Number(currentValue).toFixed(2);
                        onChange(number)
                    })

                }}
            />
        )
    }
}

DecimalField.propTypes = {
    id: PropTypes.string,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func
}